import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GenomeOption} from 'constants/GenomeConstants';
import GenomeSearchSelector, {GenomeSource} from 'molbio/genome/GenomeSearchSelector';
import ClearSearchButton from 'search/ClearSearchButton';
import FormGroup from 'ui-library/bs/FormGroup';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import FieldLabel from 'ui-library/inputs/FieldLabel';

export interface GenomeSearchSectionProps {
  selectedGenome?: GenomeOption;
  onSelectGenome: (value: GenomeOption) => void;
  isSearching: boolean;
  disableSearch: boolean;
  canClearSelection: boolean;
  onClear: () => void;
  onSearch: () => void;
  helpText?: JSX.Element;
}

function GenomeSearchSection({
  selectedGenome,
  onSelectGenome,
  isSearching,
  disableSearch,
  canClearSelection,
  onClear,
  onSearch,
  helpText,
}: GenomeSearchSectionProps): JSX.Element {
  return (
    <FormGroup>
      <FieldLabel label="Genome" />
      <div className={css(searchStyles.searchSection)}>
        <div className={css(searchStyles.accessionSearchInput)}>
          <GenomeSearchSelector
            genomeSources={[GenomeSource.ENSEMBL, GenomeSource.PRIVATE]}
            onSelectGenome={onSelectGenome}
            selectedValue={selectedGenome}
            disabled={isSearching}
          />
        </div>
        <Button
          className={css(searchStyles.genomeSearchButton)}
          disabled={!selectedGenome || isSearching || disableSearch}
          buttonStyle={ButtonStyle.SECONDARY}
          size={ButtonSize.SMALL}
          text="Search"
          onClick={onSearch}
          dataTestAttrs={{component: 'GenomeSearchSection', element: 'searchButton'}}
        />
        {(selectedGenome || canClearSelection) && !isSearching && (
          <div className={css(searchStyles.clearSearchButton)}>
            <ClearSearchButton onClear={onClear} />
          </div>
        )}
      </div>
      {helpText}
    </FormGroup>
  );
}

const searchStyles = StyleSheet.create({
  searchSection: {
    display: 'flex',
  },
  accessionSearchInput: {
    width: '50%',
  },
  searchButton: {
    margin: '4px 0 4px 16px',
  },
  genomeSearchButton: {
    marginLeft: '16px',
  },
  clearSearchButton: {
    margin: 'auto 0 auto 18px',
  },
});

export default GenomeSearchSection;
